import { connect } from 'react-redux';

// redux selectors
import {
  getProductId,
  isFetching,
  isFetchingError,
  isNotFound,
  getProductPrice,
  getProductDiscountPrice,
  getSelectedSKUID,
} from 'shared/store/details/selectors';

import { setProductOffers, setOffersFailure } from 'shared/store/details/actions';

import { isUserFetching, isPostRequestAllowed, getCartCount } from 'shared/store/app/selectors';
import { isLoggedIn } from 'shared/store/app/selectors';

// components
import ProductOffers from './ProductOffers';

const mapStateToProps = (state: any) => ({
  parentProductId: getProductId(state),
  productId: getSelectedSKUID(state) || getProductId(state),
  isFetchingDetails: isFetching(state),
  isFetchingError: isFetchingError(state),
  isUserFetching: isUserFetching(state),
  isPostRequestAllowed: isPostRequestAllowed(state),
  isNotFound: isNotFound(state),
  isLoggedIn: isLoggedIn(state),
  mrp: getProductPrice(state),
  sp: getProductDiscountPrice(state),
  cartCount: getCartCount(state),
});

const mapDispatchToProps = {
  setProductOffers,
  setOffersFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductOffers);
